import {
  sendMessage,
  type NLMessage,
  type MessageType,
} from "@nextlayer/stealth-shared";
import { getSdkOrigin } from "./config";

// merchantId is handed to the modal as a query param when the SDK opens the iframe.
function getMerchantId(): string {
  return (
    new URLSearchParams(window.location.search).get("merchantId") ?? "unknown"
  );
}

function makeMessage(type: MessageType, extra?: Partial<NLMessage>): NLMessage {
  return {
    type,
    merchantId: getMerchantId(),
    timestamp: Date.now(),
    nonce: crypto.randomUUID(),
    ...extra,
  };
}

export function emitToSdk(type: MessageType, extra?: Partial<NLMessage>): void {
  if (window.parent && window.parent !== window) {
    sendMessage(window.parent, makeMessage(type, extra), getSdkOrigin());
  }
}
